import {createStyles, Theme} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiCardHeader-root': {
            height: 56,
            fontWeight: 900,
            alignItems: 'flex-start',
            '& .MuiCardHeader-action': {
                marginLeft: '-12px',
            },
        },
    },
    body: {
        overflow: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[10],
        padding: theme.spacing(2, 4, 8),
        position: 'relative',
        maxWidth: '60%',
        minheight: '25%',
        maxHeight: '65%',
        left: '1rem',
    },
    info: {
        color: theme.palette.text.disabled,
    },
    actions: {
        marginTop: '24px',
        minheight: '10%',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'stretch',
    },
    mainBody: {overflowY: 'visible'},
    bodyActions: {
        maxHeight: '55%',
    },
    bodyFull: {
        maxHeight: '100%',
    },
}));
